import { createAsyncThunk } from '@reduxjs/toolkit'
import { TimelineAnnotation } from 'schemas/TimelineAnnotationSchema'
import TimelineAnnotationGroupVo from 'vo/TimelineAnnotation/TimelineAnnotationGroup'
import TimelineAnnotationVo from 'vo/TimelineAnnotation/TimelineAnnotation'
import * as API from '../../api'

export const updateTimelineAnnotation = createAsyncThunk(
  'topicAnnotations/updateTimelineAnnotation',
  async ({ annotation }: { annotation: TimelineAnnotation }, { rejectWithValue }) => {
    try {
      const { data } = await API.updateAnnotation(annotation)
      const transformedData = TimelineAnnotationVo(data)
      return transformedData
    } catch (err: unknown) {
      return rejectWithValue((err as any)?.response?.data)
    }
  }
)

export const deleteTimelineAnnotation = createAsyncThunk(
  'topicAnnotations/deleteTimelineAnnotation',
  async ({ annotation }: { annotation: TimelineAnnotation }, { rejectWithValue }) => {
    try {
      const { data } = await API.deleteAnnotation(annotation)
      return data
    } catch (err: unknown) {
      return rejectWithValue((err as any)?.response?.data)
    }
  }
)

export const addTimelineAnnotation = createAsyncThunk(
  'topicAnnotations/addTimelineAnnotation',
  async ({ annotation }: { annotation: TimelineAnnotation }, { rejectWithValue }) => {
    try {
      const { data } = await API.addAnnotation(annotation)
      const transformedData = TimelineAnnotationVo(data)
      return transformedData
    } catch (err: unknown) {
      return rejectWithValue((err as any)?.response?.data)
    }
  }
)

export const getTimelineAnnotationsByTopicId = createAsyncThunk(
  'topicAnnotations/getTimelineAnnotationsByTopicId',
  async ({ topicId, refresh }: { topicId: number; refresh?: boolean }, { rejectWithValue }) => {
    try {
      const { data } = await API.getAnnotations(topicId, refresh ? { staleTime: 0 } : undefined)
      const transformedData = TimelineAnnotationGroupVo(data)
      return transformedData
    } catch (err: unknown) {
      return rejectWithValue((err as any)?.response?.data)
    }
  }
)
